var FilterButton = /** @class */ (function () {
    function FilterButton(button, toggleCallback) {
        this.category = button.dataset.category;
        this.button = button;
        this.toggleCallback = toggleCallback;
        button.addEventListener('click', this.onButtonClick.bind(this));
        if (button.dataset.active) {
            this.onButtonClick();
        }
    }
    FilterButton.prototype.onButtonClick = function () {
        this.button.classList.toggle('active');
        this.toggleCallback(this);
    };
    FilterButton.prototype.reset = function () {
        this.button.classList.remove('active');
    };
    return FilterButton;
}());
export default FilterButton;
